import { RESOURCES_NAMES } from "@/const/resource.constants"
import { useHttp } from "@/hooks/useHttp"

import type { Config } from "@/hooks/useHttp"
import type {
  EvpMitigationValidation,
  IssueExploitability,
  IssueRemediation
} from "./useEvp.types"

export const useEvpIssue = <T = IssueExploitability, S = T>(
  issueId: string | undefined,
  config?: Config<T, S>
) =>
  useHttp<T, S>(
    `${RESOURCES_NAMES.EXPERIMENTAL.EVP.ISSUES}/${issueId}`,
    undefined,
    {
      enabled: !!issueId,
      ...config
    }
  )

// The Remediation tab. The backend endpoint path is still /mitigation (unchanged).
export const useEvpRemediation = <T = IssueRemediation, S = T>(
  issueId: string | undefined,
  config?: Config<T, S>
) =>
  useHttp<T, S>(
    `${RESOURCES_NAMES.EXPERIMENTAL.EVP.ISSUES}/${issueId}/mitigation`,
    undefined,
    {
      enabled: !!issueId,
      ...config
    }
  )

// The Remediation Validation modal, opened from a "Validated" link. Pass
// undefined (e.g. while the modal is closed) to skip the fetch.
export const useEvpMitigationValidation = <T = EvpMitigationValidation, S = T>(
  validationId: string | undefined,
  config?: Config<T, S>
) =>
  useHttp<T, S>(
    `${RESOURCES_NAMES.EXPERIMENTAL.EVP.MITIGATION_VALIDATIONS}/${validationId}`,
    undefined,
    {
      enabled: !!validationId,
      ...config
    }
  )
